import { useSelector } from "react-redux";

import { ReduxState } from "../types/redux.types";
import { IEnums } from "../types/resource.types";

const useGetEnumsAsChoices = <T extends keyof IEnums>(enumEntry: T): ReturnValue => {
  const enums = useSelector<ReduxState, IEnums>((state) => state.enums);

  if (enums[enumEntry]) {
    return Object.entries<any>(enums[enumEntry])
      .sort(([id1], [id2]) => (id1 < id2 ? -1 : 1))
      .map(([id, value]) => {
        return {
          id,
          name: value.label ? value.label.en : value.en,
        };
      });
  }
  return [{ id: "", name: "" }];
};

type ReturnValue = {
  id: string;
  name: string;
}[];

export default useGetEnumsAsChoices;
